import React from 'react';
import { ListItem, Text } from '@rneui/themed';
import { useTheme } from '../../..';
const pad = (num) => `${num >= 10 ? num : `0${num}`}`;
const timeString = (duration) => {
    const hours = Math.floor(duration / 60 / 60);
    const minutes = Math.floor((duration - (hours * 60 * 60)) / 60);
    const seconds = Math.floor(duration - (hours * 60 * 60) - (minutes * 60));
    if (hours) {
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }
    return `${pad(minutes)}:${pad(seconds)}`;
};
export const ChapterItem = ({ chapter, onPress = () => { }, active = false, }) => {
    const { colors } = useTheme();
    return (React.createElement(ListItem, { onPress: () => onPress(chapter.location), disabled: active, disabledStyle: {
            backgroundColor: colors.accent,
            opacity: 0.5,
        } },
        React.createElement(ListItem.Content, null,
            React.createElement(Text, null, chapter.name)),
        React.createElement(Text, null, timeString(chapter.duration))));
};
//# sourceMappingURL=ChapterItem.js.map